import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { Grid, InputLabel } from '@mui/material';
import { Dialog, IconButton, TextField, Card, Button } from '@totalsoft/rocket-ui';
import { PlayArrow } from '@mui/icons-material';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const OfferPartnerQuestionListItemComponent = ({ t, currentQuestion, editQuestionnaireMode, onStartQuestionnaireSpecificQuestion }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleStartFromSelectedQuestion = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleStartFromSelectedQuestionAccepted = () => {
    onStartQuestionnaireSpecificQuestion(currentQuestion.questionNo);
    setDialogOpen(false);
  };

  return (
    <Card>
      <Grid container justifyContent='space-between'>
        <Grid item>
          <InputLabel color='primary'>
            {currentQuestion.questionNo}.{currentQuestion.questionName}
          </InputLabel>
        </Grid>
        <Grid item gap={1} sx={{ display: 'flex' }} alignItems='center'>
          <InputLabel color='primary'>
            {currentQuestion.questionTypeCode === 'TP_DATE' ? (
              <>{t('DATE', { date: currentQuestion.answer })}</>
            ) : currentQuestion.questionTypeCode === 'TP_NUM' ? (
              <>{t('NUMBER', { number: currentQuestion.answer })}</>
            ) : (
              <>{currentQuestion.answer}</>
            )}
          </InputLabel>
          {currentQuestion.questionScore !== null && (
            <InputLabel>
              {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.QuestionScore')}
              {currentQuestion.questionScore}
            </InputLabel>
          )}
          {editQuestionnaireMode && (
            <IconButton
              onClick={handleStartFromSelectedQuestion}
              title={t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.StartFromThisQuestion')}
              color='primary'
              size='small'
              variant='text'
            >
              <PlayArrow />
            </IconButton>
          )}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <TextField
            multiline
            fullWidth
            value={currentQuestion.freeTxt}
            label={t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.FreeTxt')}
            disabled={true}
          />
        </Grid>
      </Grid>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        title={t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.Title')}
        content={
          <>
            {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.Description')}
            {currentQuestion.questionNo}
            {'?'}
          </>
        }
        actions={
          <BoxActionsWrapper forDialog>
            <Button autoFocus onClick={handleStartFromSelectedQuestionAccepted}>
              {t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.AcceptButton')}
            </Button>
            <Button onClick={handleClose}>{t('OfferEdit.Client.Questionnaire.DocumentPartnerQuestion.RejectButton')}</Button>
          </BoxActionsWrapper>
        }
      />
    </Card>
  );
};

OfferPartnerQuestionListItemComponent.propTypes = {
  t: PropTypes.func.isRequired,
  currentQuestion: PropTypes.object.isRequired,
  questionnaire: PropTypes.object.isRequired,
  editQuestionnaireMode: PropTypes.bool.isRequired,
  onStartQuestionnaireSpecificQuestion: PropTypes.func.isRequired
};

export default compose(withTranslation())(OfferPartnerQuestionListItemComponent);
